module.exports = __webpack_public_path__ + "img/cape-verde.1e8fe55c.svg";